<template>
  <div class="read-more-container">
    <div class="text truncated" v-if="!showFullText">{{ truncatedText }}</div>
    <div class="text full" v-if="showFullText">{{ text }}</div>
    <span
      @click="showAllText" v-if="showButton && !showFullText"
      class="read-more"
      >Read more
    </span>
  </div>
</template>
<script lang="ts">
import { ref, defineComponent } from "vue";

export default defineComponent({
  props: {
    text: {
      type: String,
      required: false,
      default: " ", // display an empty string
    },
    defaultChars: {
      type: Number,
      default: 700,
    },
  },
  data() {
    return {
      showFullText: false,
    };
  },
  computed: {
    truncatedText() {
      return this.showFullText
        ? this.text
        : this.text.slice(0, this.defaultChars);
    },
    showButton() {
      return this.text.length > this.defaultChars;
    },
  },
  methods: {
    showAllText() {
      this.showFullText = !this.showFullText;
    },
  },
});
</script>
<style scoped lang="scss">
.text {
  display: block;
  word-break: break-word;
}

.read-more {
  color: #999;
  text-decoration: underline;
  font-size: 12px;
  cursor: pointer;
}
</style>
